import {
  EYE_HEIGHT,
  floors,
  rooms,
  roomContainsPoint,
  type FloorConfig,
  type RoomConfig,
} from '../mansion/MansionLayout';
export function floorAtEyeHeight(y: number): FloorConfig {
  const feet = y - EYE_HEIGHT;
  return floors.find((f) => feet >= f.minY && feet < f.maxY) ?? floors[0];
}
export function roomAtPosition(x: number, eyeY: number, z: number): RoomConfig | undefined {
  const floor = floorAtEyeHeight(eyeY);
  return rooms.find((r) => r.floor === floor.id && roomContainsPoint(r, x, z));
}
